import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth tokens are stored ONLY in an httpOnly secure cookie set by the
// backend. We do not persist them in localStorage to avoid XSS exfiltration.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
